module.exports = __webpack_public_path__ + "img/coupon.4e2957e7.png";